// @ts-nocheck
import moment from "moment-timezone";

export const useWorkflowBootedAtFormat = (timeZone, workflow_booted_at, format) => {
  let replaced_format = "";
  replaced_format = format
    .replace(/%Y/, "YYYY")
    .replace(/%m/, "MM")
    .replace(/%d/, "DD")
    .replace(/%H/, "HH")
    .replace(/%M/, "mm");

  const result = moment.parseZone(workflow_booted_at).utc().tz(timeZone);
  return result.isValid() ? result.format(replaced_format) : "";
};
